import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';

@Component
export class BodyOverlay extends ThemeComponent {
    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    init() {
        this.$listen(this, 'click', () => {
            this._onCloseChange.dispatch(this.close);
            this.closeOverlay();
        });
    }

    public openOverlay() {
        this.classList.remove('hidden');
        setTimeout(() => {
            this.classList.add('visible');
        }, 10);
    }

    public closeOverlay() {
        // Remove the 'visible' class to trigger the transition
        this.classList.remove('visible');
        setTimeout(() => {
            this.classList.add('hidden');
        }, 300);
    }
}
